// This file is no longer needed since we've removed server-side preview functionality.
// All preview functionality is now handled client-side by the ClientSidePreview.vue component.
// 
// If you need this file for any remaining functionality, you can restore it,
// but currently all preview generation happens in the browser using Vue.js

console.warn('useCvPreview composable is deprecated - preview functionality is now handled client-side')

export function useCvPreview() {
  return {
    isPreviewLoading: false,
    previewError: null,
    previewHtml: '',
    generatePreview: () => console.warn('Server-side preview generation has been removed'),
    refreshPreview: () => console.warn('Server-side preview generation has been removed')
  }
}